import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const STUDENTS_CACHE_KEY = (classId) => `instclass_students_${classId}`;
const CLASSMETA_KEY = (classId) => `instclass_meta_${classId}`;
const VERSION_CACHE_KEY = (classId) => `instclass_version_${classId}`;

/**
 * Obtiene el listado de alumnos y metadatos de una clase institucional.
 * Actualiza el caché local automáticamente.
 */
export async function fetchAndCacheInstitutionalStudents(classId, remoteVersion) {
  try {
    console.log(`[Guardian] Sincronizando clase ${classId} (v${remoteVersion})...`);
    const classRef = doc(db, 'clases_institucionales', classId);
    const summaryRef = doc(db, 'clases_institucionales', classId, 'students_summary', 'summary');
    
    const [classSnap, summarySnap] = await Promise.all([getDoc(classRef), getDoc(summaryRef)]);

    let meta = { section: '', name: '' };
    if (classSnap.exists()) {
      const d = classSnap.data();
      meta = {
        section: d.section ?? '',
        name: d.name ?? d.nombre ?? ''
      };
      localStorage.setItem(CLASSMETA_KEY(classId), JSON.stringify(meta));
    }

    let estudiantes = [];
    if (summarySnap.exists()) {
      const data = summarySnap.data();
      estudiantes = data.estudiantes || [];
      localStorage.setItem(STUDENTS_CACHE_KEY(classId), JSON.stringify(estudiantes));
      
      // Guardar la versión localmente para que el Guardián sepa que ya está al día
      if (remoteVersion) {
        localStorage.setItem(VERSION_CACHE_KEY(classId), String(remoteVersion));
      }
    }

    return { estudiantes, meta };
  } catch (err) {
    console.error(`[Guardian] Error sincronizando clase ${classId}:`, err);
    throw err;
  }
}
